import { ArrowDown, ArrowUp, GripVertical } from "lucide-react";
import { IconButton } from "../../../ui/IconButton";
import type { DragHandleProps } from "./useReorder";

export type ReorderControlsProps = {
  index: number;
  count: number;
  onStep: (index: number, direction: -1 | 1) => void;
  /** Drag from the grip (desktop; hidden on phones, where the arrows do it) */
  handleProps?: DragHandleProps;
  disabled?: boolean;
  /** The tooltip while disabled, e.g. "Clear the search to reorder" */
  disabledReason?: string;
};

/** A row's reorder controls: a drag grip, Move up, Move down. */
export function ReorderControls({ index, count, onStep, handleProps, disabled = false, disabledReason }: ReorderControlsProps) {
  return (
    <div className="reorder-controls" data-tooltip={disabled && disabledReason ? disabledReason : undefined}>
      {handleProps && (
        <span
          className={`reorder-handle${disabled ? " is-disabled" : ""}`}
          aria-hidden="true"
          data-tooltip={disabled ? undefined : "Drag to reorder"}
          {...(disabled ? {} : handleProps)}
        >
          <GripVertical size={16} />
        </span>
      )}
      <IconButton
        size="sm"
        label="Move up"
        tooltip={disabled ? false : undefined}
        icon={<ArrowUp size={16} />}
        onClick={() => onStep(index, -1)}
        disabled={disabled || index === 0}
      />
      <IconButton
        size="sm"
        label="Move down"
        tooltip={disabled ? false : undefined}
        icon={<ArrowDown size={16} />}
        onClick={() => onStep(index, 1)}
        disabled={disabled || index >= count - 1}
      />
    </div>
  );
}

export default ReorderControls;
